<template>
  <el-dialog title="上传文件" :visible.sync="dialogVisible" :before-close="handleClose">
    <el-row :gutter="24">
      <el-col :span="18">
        <div class="grid-content bg-purple">
          <div>
            <el-input v-model="input" placeholder="请输入内容">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch">
              </el-button>
            </el-input>
          </div>
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>文件</span>
              <div style="display: flex; align-items: center;">

                <el-popover placement="bottom-start" title="类型" width="200" trigger="hover">
                  <el-checkbox-group v-model="checkList">
                    <el-checkbox label="图片"></el-checkbox>
                    <el-checkbox label="文件"></el-checkbox>
                    <el-checkbox label="视频"></el-checkbox>
                  </el-checkbox-group>
                  <!-- 触发元素 -->
                  <el-button slot="reference" icon="font-icon font-icon-shai" size="small" circle></el-button>
                </el-popover>

                <el-divider direction="vertical"></el-divider>
                <el-upload
                class="upload-demo"
                action="https://mdy-n.modianyun.com/apis/applet/uploads"
                  :show-file-list="false"
                   :on-success="handleSess"
                  >
                  <el-button type="primary" size="mini" icon="el-icon-upload" round>上传文件</el-button>
                </el-upload>

              </div>
            </div>
            <div class="demo-image__lazy">
              <div class="imgList" v-for="(item, index) in imgData" :key="index" @click="handleCheckImg(index)">
                <el-image :class="Selectedq(item) && 'imgActive'" :src="item.url" lazy>
                </el-image>
                <p style="margin: 0; text-align: center;">{{ item.filename }}</p>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="6">
        <div v-if="imgObj.media_id" class="grid-content bg-purple left_info">
          <div>
            <div class="imgs">
              <el-image :src="imgObj.url" lazy>
              </el-image>
            </div>
            <el-tooltip class="item" effect="dark" :content="imgObj.filename" placement="top-start">
            <el-button style="width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ imgObj.filename }}</el-button>
            </el-tooltip>
          </div>
          <div class="fileInfo">
            <div class="fileInfo_item">
              <span>文件类型</span>
              <span>{{ imgObj.category }}</span>
            </div>
            <!-- <div class="fileInfo_item">
              <span>尺寸</span>
              <span>630 × 444</span>
            </div> -->
            <!-- <div class="fileInfo_item">
              <span>大小</span>
              <span>{{imgObj.}}KB</span>
            </div> -->
            <div class="fileInfo_item">
              <span>URL</span>
              <span><el-button type="primary" size="mini" plain>复制</el-button></span>
            </div>
            <!-- <div class="fileInfo_item">
              <span>添加时间</span>
              <span>1</span>
            </div> -->
          </div>
        </div>
        <div v-else style="text-align: center;">
          <img src="../../assets/no-support.svg" alt="">
          <p>暂无选择内容~</p>
        </div>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-between;">
      <div> <el-pagination @current-change="handleCurrentChange"
          :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination></div>
      <div>
        <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleOk">确 定</el-button>
      </div>
    </span>
  </el-dialog>
</template>
<script>
import upImg from '../../assets/infoimg.jpg'
import hssp from '../../assets/video/hssp.mp4'
import api from '../../api/index'
export default {
  name: 'imgPre',
  props: {
    data: Object,
    dialogVisible: Boolean
  },
  data () {
    return {
      activeNames: ['1'],
      input: '',
      checkList: [],
      imgData: [],
      imgObj: {},
      currentPage1: 1,
      totalNum: 0
    }
  },
  mounted () {
    this.getimgList()
  },
  methods: {
    handleClose: function () {
      this.$emit('onClose')
    },
    handleSess: function (response, file, fileList) {
      console.log('选择的文件', response)
      if (response.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.getimgList()
      }
    },
    handleOk: function () {
      this.$emit('checkImg', this.imgObj)
    },
    handleCheckImg: function (index) {
      const temp = this.imgData[index]
      if (temp.media_id) {
        this.imgObj = temp
      } else {
        this.imgObj = null
      }
      console.log('选择得图片', index, this.Selectedq(temp))
    },

    Selectedq: function (item) {
      // 判断当前项是否在选中的列表中
      return this.imgObj.media_id === item.media_id
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.currentPage1 = val
      this.getimgList()
    },
    handleSearch () {
      this.getimgList()
    },
    // 获取图片 视频列表
    async getimgList () {
      try {
        const data = { page: this.currentPage1, pagesize: '10', sname: this.input } // 需要发送的请求数据
        const response = await api.post('/applet/get_img', data)
        console.log('请求图片数据:', response)
        if (response.code === 0) {
          this.imgData = response.data.data.data
          this.totalNum = response.data.data.total
          this.currentPage1 = response.data.data.current_page
        }
      } catch (error) {
        console.error('Error sending data:', error)
      }
    }
  }
}
</script>
<style scoped>
.box-card {
  border: none;
}

/deep/ .el-card__header {
  padding: 18px 0 !important;
}
/deep/ .el-image__inner {
  object-fit: contain;
}
/deep/ .el-dialog__header {
  padding: 0;
  padding-left: 20px;
  line-height: 54px;
  background: #409eff;
}

/deep/ .el-dialog__title {
  color: #ffffff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}

.box-card .el-card__header span {
  font-size: 18px;
  font-weight: 600;
}

/deep/ .el-card__body {
  padding: 20px 0 !important;
  max-height: 400px;
  overflow-y: auto;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.font-icon {
  font-size: 16px;
}

.demo-image__lazy {
  display: grid;
  /* 使用 grid 布局 */
  grid-template-columns: repeat(5, 1fr);
  /* 创建五个等宽的列 */
  gap: 10px;
  /* 列之间的间隙 */
}

.demo-image__lazy .imgList {
  margin-bottom: 10px;
  flex: 0 1 19%;
  overflow: hidden;
}

.demo-image__lazy .imgList p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.demo-image__lazy .imgList .el-image {
  width: 100%;
  height: 150px;
  border: 2px solid transparent;
  position: relative;
  cursor: pointer;
}

.demo-image__lazy .imgList .el-image:hover::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}

.imgActive {
  border-color: aqua !important;
}

.left_info {
  height: 100%;
}

.imgs {
  display: block;
  height: 200px;
  margin-bottom: 8px;
  border-radius: 6px;
  text-align: center;
  border: 1px solid #efefef;
  position: relative;
  background: #efefef;
}

.imgs .el-image {
  max-width: 100%;
  max-height: 100%;
  display: inline-block;
  vertical-align: middle;
}

.fileInfo_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/uploadImg/imgPre.vue